// Where a composer send runs: Pieve's models on the server, or the person's Claude plan through Pieve Desktop on this Mac.
const COMPOSER_RUN_TARGET_KIND = Object.freeze({ pieve: 'pieve', plan: 'plan' });

export default COMPOSER_RUN_TARGET_KIND;
